import Button from '@/common/components/Button'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useMaintenanceExecutionObjectiveApprove } from '@/features/maintenanceWorkflow/pages/Show/features/directiveEntries/features/execution/hooks/useMaintenanceExecutionObjectiveApprove'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface MaintenanceExecutionObjectiveApproveProps {
  objectiveId: string
  onApprove?: VoidFunction
}

export const MaintenanceExecutionObjectiveApprove = ({
  objectiveId,
  onApprove,
}: MaintenanceExecutionObjectiveApproveProps) => {
  const { forwardingId } = useParams()

  const queryClient = useQueryClient()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: approve, isPending: approveIsPending } = useMaintenanceExecutionObjectiveApprove({
    objectiveId,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwardingId],
        })

        onApprove?.()
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error)
      },
    },
  })

  return (
    <>
      <Button
        variant="success"
        onClick={() => approve()}
        isLoading={approveIsPending}
        operationKlassToCheckPermission="Client::Maintenance::ExecutionObjectives::Update"
      >
        Aprovar
      </Button>

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
